import { doc, updateDoc, deleteField } from 'firebase/firestore';
import { ProductType, StateProduct } from './ProductPageInterfaces';
import { knowledgeInterface } from '../../containers/KnowledgePage/KnowledgePageInterfaces';
import { db } from '../../config/firebase';
import strings from '../../resources/strings';
import { Mission } from '../../store/missions/types';
import { status } from '../../utils/StatusCalculator';
import SidebarSecondStatuses from '../../resources/enums/SidebarSecondStatuses';

export const getTableColumns = (productType?: ProductType) => {
    return [
        {
            disablePadding: false,
            id: '1',
            label: strings.productsPage.table.paid,
            numeric: false,
        },
        {
            disablePadding: false,
            id: '2',
            label: productType ? strings.productsPage.tableProductHeader[productType] : '',
            numeric: false,
        },
        {
            disablePadding: false,
            id: '3',
            label: strings.productsPage.table.price,
            numeric: true,
        },
    ];
};

export const getSelectOptions = () =>
    Object.keys(ProductType).map((item) => ({
        value: item.toLowerCase(),
        label: `${item}s`,
    }));

export const mapMissionsToProducts = (missions: Mission[]) => {
    return missions.reduce((acc, cur) => {
        if (status(cur?.publishTo ?? null, cur?.publishFrom ?? null) !== SidebarSecondStatuses.active) return acc;

        const mission = {
            id: cur.id,
            title: cur.name?.en || cur.name?.pl,
            paid: cur?.paid || false,
            price: String(cur?.price ? cur?.price : 0),
        };

        return [...acc, mission];
    }, [] as StateProduct[]);
};

export const mapExternalToProducts = (contents: knowledgeInterface[]) => {
    return contents.reduce((acc, cur) => {
        if (status(cur?.publishTo ?? null, cur?.publishFrom ?? null) !== SidebarSecondStatuses.active) return acc;

        const content = {
            id: cur.id,
            title: cur.title?.en || cur.title?.pl,
            paid: cur?.paid || false,
            price: String(cur?.price ? cur?.price : 0),
        };

        return [...acc, content];
    }, [] as StateProduct[]);
};

export const trimForInteger = (input: string | number) => String(input).replace(/\D/g, '');

export const updateResources = (products: StateProduct[], dbCollection: string) => {
    return products.map((product) => {
        return updateDoc(doc(db, dbCollection, product.id), {
            paid: product.paid || deleteField(),
            price: product.paid ? Number(product.price) : deleteField(),
        });
    });
};
